import angular from "angular";
import { SignatureDirective, vsDirectiveName } from "./component";

export const vsModuleName = "ui.signature";

angular.module(vsModuleName, []).directive(vsDirectiveName, SignatureDirective);
